export default __webpack_public_path__ + "static/media/vegetable.36266a27.png";